module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "btns",
    staticClass: "btns",
    on: {
      "click": function($event) {
        _vm.click($event)
      },
      "mouseenter": _vm.mouseenter,
      "mouseleave": _vm.mouseleave
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('canvas', {
    ref: "btnCan",
    attrs: {
      "id": "canvas"
    },
    on: {
      "click": _vm.press,
      "mouseenter": _vm.can
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c6330080"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/button.vue
// module id = 337
// module chunks = 4